import React from 'react'

const sizes = {
    wide: 'lg',
    medium: 'md',
    narrow: 'sm',
}

const Logo = ({logo, format, teaserClass=''}) => (
    <div className={['logo', sizes[format], teaserClass].filter(Boolean).join(' ')}>
        <img src={logo} alt="logo" />
    </div>
)

export default Logo



// WEBPACK FOOTER //
// ./src/components/subcomponents/Logo.js